import React, { useEffect, useRef } from "react";
import "../styles/Hero.css";
import logo from "../assets/images/successstation-logo.png";

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    // Add fly-in classes after mount for animation
    const content = heroRef.current;
    if (content) {
      const children = content.querySelectorAll(".fly-in");
      children.forEach((el, i) => {
        setTimeout(() => {
          el.style.opacity = 1;
        }, 100 + i * 200);
      });
    }
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content" ref={heroRef}>
        <img
          src={logo}
          alt="Success Station Logo"
          className="hero-logo fly-in fly-in-1"
        />
        <h3 className="fly-in fly-in-2">
          UDHYAM REGISTERED: (MSME) MP-24- 0060827
        </h3>

        <h1 className="fly-in fly-in-4">
          Training for Professional Career Guidance, Career Development,
          Leadership skills is not a part of the curriculums of Schools or
          Colleges.
        </h1>
        <p className="fly-in fly-in-4">
          Need the right skills and experience to take you to the next level?
          It's my job to get to know your goals and find the perfect solution
          for you.
        </p>
        <a
          href="#contact"
          className="cta-button fly-in fly-in-4"
          onClick={scrollToContact}
        >
          Let's Talk
        </a>
      </div>
    </section>
  );
};

export default Hero;
